/**
 * Axios Configuration
 * Sets up interceptors for authentication
 */

import axios from 'axios';

// Helper function to get CSRF token from cookies
function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

// Add request interceptor to include auth token, CSRF token, and impersonation token
axios.interceptors.request.use(
  (config) => {
    // Add authentication token
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    // Add impersonation token if present
    const impersonationToken = localStorage.getItem('impersonationToken');
    if (impersonationToken) {
      config.headers['X-Impersonation-Token'] = impersonationToken;
    }

    // Add CSRF token for POST/PUT/DELETE/PATCH requests
    if (['post', 'put', 'delete', 'patch'].includes(config.method?.toLowerCase() || '')) {
      const csrfToken = getCookie('csrftoken');
      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login (only if not already on login page)
      localStorage.removeItem('authToken');
      localStorage.removeItem('username');

      // Only redirect if we're not already on the login page to avoid redirect loops
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
